module.exports = __webpack_public_path__ + "static/media/avatar-default.39108a93.svg";